<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :fill="pathFill"
    width="80"
    height="80"
    viewBox="0 0 24 24"
  >
    <path
      d="M1,16V8A1,1,0,0,1,3,8v8a1,1,0,0,1-2,0Zm7,4V4A1,1,0,0,0,6,4V20a1,1,0,0,0,2,0Zm5,2V2a1,1,0,0,0-2,0V22a1,1,0,0,0,2,0Zm5-2V4a1,1,0,0,0-2,0V20a1,1,0,0,0,2,0ZM22,7a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V8A1,1,0,0,0,22,7Z"
    />
  </svg>
</template>
<script>
export default {
  name: 'AudioMixerIcon',
  props: {
    pathFill: {
      type: String,
      default: '#ffffff',
    },
  },
};
</script>
